import initialState from "./initial.value";
import { SET_CURRENTUSER, SET_USERPERMISSIONS, SET_CITIES, SET_BANKS, SET_BANK_LABELS, SET_ITEMS, SET_VARIANTS, SET_DEALERS, SET_SALESPERSONS, SET_CORPORATECLIENTS, SET_SOURCE, SET_MAKE, SET_MODEL, SET_PARTS_VARIANT, SET_PARTS_COLORS, SET_CATEGORY, SET_VENDOR, SET_TAX, SET_DISCOUNT } from './action';

const rootReducer = (state = initialState, action) => {

  switch (action.type) {
    case SET_USERPERMISSIONS:
      return { ...state, permission: action.payload, };
    case SET_CURRENTUSER:
      return { ...state, user: action.payload, };
    case SET_CITIES:
      return { ...state, cities: action.payload };
    case SET_BANKS:
      return { ...state, banks: action.payload };
    case SET_BANK_LABELS:
      return { ...state, bankLabels: action.payload };
    case SET_ITEMS:
      return { ...state, items: action.payload };
    case SET_VARIANTS:
      return { ...state, variants: action.payload };
    case SET_DEALERS:
      return { ...state, dealers: action.payload };
    case SET_SALESPERSONS:
      return { ...state, salesPersons: action.payload };
    case SET_CORPORATECLIENTS:
      return { ...state, corporateClients: action.payload };
    case SET_SOURCE:
      return { ...state, source: action.payload };
    case SET_MAKE:
      return { ...state, make: action.payload };
    case SET_MODEL:
      return { ...state, model: action.payload };
    case SET_PARTS_VARIANT:
      return { ...state, parts_variant: action.payload };
    case SET_PARTS_COLORS:
      return { ...state, parts_color: action.payload };
    case SET_CATEGORY:
      return { ...state, category: action.payload };
    case SET_VENDOR:
      return { ...state, vendors: action.payload };
    case SET_TAX:
      return { ...state, tax: action.payload };
    case SET_DISCOUNT:
      return { ...state, discount: action.payload };
    case "Product_list":
      return { ...state, product_list: action.payload };
    case "Dashbaord_RecentProduct":
      return { ...state, dashboard_recentproduct: action.payload };
    case "Dashbaord_ExpiredProduct":
      return { ...state, dashboard_expiredproduct: action.payload };
    case "Salesdashbaord_ExpiredProduct":
      return { ...state, saleshdashboard_recenttransaction: action.payload };
    case "Brand_list":
      return { ...state, brand_list: action.payload };

    case "Unit_Data":
      return { ...state, unit_data: action.payload };
    case "Variantattribute_Data":
      return { ...state, variantattributes_data: action.payload };
    case "Warranty_Data":
      return { ...state, warranty_data: action.payload };
    case "Barcode_Data":
      return { ...state, barcode_data: action.payload };
    case "Department_Data":
      return { ...state, departmentlist_data: action.payload };
    case "Designation_Data":
      return { ...state, designation_data: action.payload };
    case "Shiftlist_Data":
      return { ...state, shiftlist_data: action.payload };
    case "Attendenceemployee_Data":
      return { ...state, attendenceemployee_data: action.payload };
    case "toggle_header":
      return { ...state, toggle_header: action.payload };
    case "Invoicereport_Data":
      return { ...state, invoicereport_data: action.payload };
    case "Salesreturns_Data":
      return { ...state, salesreturns_data: action.payload };
    case "Quatation_Data":
      return { ...state, quotationlist_data: action.payload };
    case "customer_data":
      return { ...state, customerdata: action.payload };
    case "Userlist_data":
      return { ...state, userlist_data: action.payload };
    case "Rolesandpermission_data":
      return { ...state, rolesandpermission_data: action.payload };
    case "Deleteaccount_data":
      return { ...state, deleteaccount_data: action.payload };
    case "Attendenceadmin_data":
      return { ...state, attendanceadmin_data: action.payload };
    case "Leavesadmin_data":
      return { ...state, leavesadmin_data: action.payload };
    case "Leavestype_data":
      return { ...state, leavetypes_data: action.payload };
    case "Holiday_data":
      return { ...state, holiday_data: action.payload };
    case "Expiredproduct_data":
      return { ...state, expiredproduct_data: action.payload };
    case "Lowstock_data":
      return { ...state, lowstock_data: action.payload };
    case "Categotylist_data":
      return { ...state, categotylist_data: action.payload };
    case "Layoutstyle_data":
      return { ...state, layoutstyledata: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
